'use strict';
var base = require('./base');
var quickViewBase = require('base/product/quickView');
var slickSlider = require('../thirdParty/slickSlider');
var floatingLabel = require('../components/floatingLabel');
var focusHelper = require('../components/focus');
var debounce = require('lodash/debounce');
var eGiftCard = require('../product/eGiftCard');
var giftMessage = require('../components/giftMessage');
var quickShopDataLayer = require('./quickShopDataLayer');
var scrollMore = require('../components/quickViewScrollMore');

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var header = $html.find('.modal-header.quickview-header').children();
    var body = $html.find('.product-quickview');
    var float = $html.find('.modal-float').children();
    var footer = $html.find('.modal-footer').children();

    return { header: header, body: body, footer: footer, float: float };
}

/**
 * Loads javascript for PDP videos
 */
function loadPDPVideos() {
    var isMobile = $(window).width() < 992;
    var cldPlayers = [];

    $('.quick-modal video.cld-video-player').each(function () {
        if ($(this).closest('.quick-modal').length > 0) {
            var quickModalID = $(this).closest('.quick-modal').attr('id');
            $(this).attr('id', $(this).attr('id') + '-' + quickModalID);
        }
        if ($(this).closest('.quickview-mobile-carousel').length > 0) $(this).attr('id', $(this).attr('id') + '-mobile');
        if ($(this).closest('.quickview-desktop-carousel').length > 0) $(this).attr('id', $(this).attr('id') + '-desktop');

        var cldPlayerID = $(this).prop('id');
        if (cldPlayerID) {
            var cloudName = $(this).data('cloud-name');
            var position = $(this).data('position');
            position = position ? parseInt(position, 10) : position;

            // eslint-disable-next-line no-undef
            var player = cloudinary.videoPlayer(cldPlayerID, {
                cloudName: cloudName,
                controls: true,
                muted: true,
                autoplayMode: (!isMobile || position === 1) ? 'on-scroll' : 'never',
                playsinline: true,
                aspectRatio: '880:990',
                showLogo: false,
                loop: true
            });

            player.on('play', function () {
                player.videojs.autoplayOnScroll();
            });

            player.on('loadeddata', function () {
                if (player.duration() >= 20) {
                    player.loop(false);
                }
            });

            cldPlayers.push(player);
        }
    });

    $('.quickview-mobile-carousel .pdp-main-carousel.slick-slider').on('afterChange', function (event, slick, currentSlide) { // eslint-disable-line no-unused-vars
        var activeCloudinaryVideoPlayerID = null;
        var $activeCarouselItem = $(this).find('.slick-current').find('.carousel-item');
        if ($activeCarouselItem && $activeCarouselItem.length && $activeCarouselItem.hasClass('pdp-video')) {
            activeCloudinaryVideoPlayerID = $activeCarouselItem.find('.cld-video-player').prop('id');
        }

        cldPlayers.forEach(player => {
            if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                player.play();
            } else {
                player.pause();
            }
        });
    });

    var isTouchClick = null;
    var $disabledSlickSlider = null;
    $('.quick-modal .pdp-video').on('touchstart', function (event) {
        isTouchClick = true;


        var isVolumeControl = false;
        if (event && event.target) {
            isVolumeControl = $(event.target).closest('.vjs-volume-panel').length > 0;
        }

        if (isVolumeControl) {
            var $slickSlider = $(event.target).closest('.slick-slider');
            if ($slickSlider && $slickSlider.length) {
                $disabledSlickSlider = $slickSlider;
                $slickSlider.slick('slickSetOption', 'accessibility', false);
                $slickSlider.slick('slickSetOption', 'draggable', false);
                $slickSlider.slick('slickSetOption', 'swipe', false);
                $slickSlider.slick('slickSetOption', 'touchMove', false);
            }
        }
    });
    $('.quick-modal .pdp-video').on('touchmove', function () {
        isTouchClick = false;
    });
    $('.quick-modal .pdp-video').on('touchend', function (event) {
        var isVolumeControl = false;
        if (event && event.target) {
            isVolumeControl = $(event.target).closest('.vjs-volume-panel').length > 0;
        }

        if (isTouchClick && !isVolumeControl) {
            var activeCloudinaryVideoPlayerID = $(this).find('.cld-video-player').prop('id');
            cldPlayers.forEach(player => {
                if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                    if (player.videojs.paused()) {
                        player.play();
                    } else {
                        player.pause();
                    }
                }
            });
        }

        if ($disabledSlickSlider) {
            $disabledSlickSlider.slick('slickSetOption', 'accessibility', true);
            $disabledSlickSlider.slick('slickSetOption', 'draggable', true);
            $disabledSlickSlider.slick('slickSetOption', 'swipe', true);
            $disabledSlickSlider.slick('slickSetOption', 'touchMove', true);
            $disabledSlickSlider = null;
        }
    });

    // Pause
    $('.quick-modal .pdp-video-pause-button').on('click', function () {
        var $pauseButton = $(this);
        var activeCloudinaryVideoPlayerID = $(this).siblings('.cld-video-player').prop('id');
        cldPlayers.forEach(player => {
            if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                player.pause();
                $pauseButton.css('display', '');
            }
        });
    });

    $('.quick-modal .pdp-video').on('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && $(e.target).hasClass('pdp-video-pause-span')) {
            e.preventDefault();
            var $pdpVideo = $(this);
            var activeCloudinaryVideoPlayerID = $pdpVideo.find('.cld-video-player').prop('id');
            cldPlayers.forEach(player => {
                if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                    player.pause();
                    $pdpVideo.find('.pdp-video-pause-button').css('display', 'none');
                }
            });
            setTimeout(function () {
                $pdpVideo.find('.vjs-big-play-button').trigger('focus');
            }, 100);
        }
    });

    // Play
    $('.quick-modal .vjs-big-play-button').on('click', function () {
        var $pdpVideo = $(this).closest('.pdp-video');
        $pdpVideo.find('.pdp-video-pause-button').css('display', '');
        var activeCloudinaryVideoPlayerID = $pdpVideo.find('.cld-video-player').prop('id');
        cldPlayers.forEach(player => {
            if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                player.play();
            }
        });
    });

    $('.quick-modal .vjs-big-play-button').on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var $pdpVideo = $(this).closest('.pdp-video');
            var $pauseButton = $pdpVideo.find('.pdp-video-pause-button');
            $pauseButton.css('display', 'block');
            $pauseButton.find('span').trigger('focus');
            var activeCloudinaryVideoPlayerID = $pdpVideo.find('.cld-video-player').prop('id');
            cldPlayers.forEach(player => {
                if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                    player.play();
                }
            });
        }
    });
}

/**
 * Initializes quickview mobile slider
 */
function initMobileSlider() {
    var $selector = $('.quickview-mobile-carousel').find('.carousel-inner');
    if ($selector.length === 0) {
        return;
    }
    var $defaultValues = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        fade: false,
        speed: 400,
        prevArrow: $('.carousel-control-prev', this),
        nextArrow: $('.carousel-control-next', this),
        customPaging: function (slider, i) {
            return `<span class="button" type="button" id="slick-slide-control0${i}" aria-controls="slick-slide0${i}" tabindex="${i === 0 ? 0 : -1}" role="tab" aria-label="Slide ${i + 1} of ${slider.slideCount}">${i + 1}</span>`;
        }
    };
    var $responsiveValues = {
        dots: false,
        arrows: false,
        draggable: true,
        centerMode: true
    };

    var $initialized = $selector.filter(function () {
        return $(this).hasClass('slick-initialized') && (!!$(this).data('slick') || !!this.slick);
    });

    var $uninitialized = $selector.filter(function () {
        return !($(this).hasClass('slick-initialized') && (!!$(this).data('slick') || !!this.slick));
    });

    if ($initialized.length > 0) {
        $initialized.slick('resize');
    }

    if ($uninitialized.length > 0) {
        $uninitialized.each(function () {
            if ($(this).hasClass('slick-initialized')) {
                try {
                    $(this).slick('unslick');
                } catch (e) {
                    $(this).removeClass('slick-initialized');
                }
            }
        });
        slickSlider.init($uninitialized, $defaultValues, $responsiveValues);

        // setTimeout(function() {
        //     var $newlyInitialized = $uninitialized.filter('.slick-initialized');
        //     if ($newlyInitialized.length) {
        //         $newlyInitialized[0].slick.setPosition();
        //         $newlyInitialized.slick('resize');
        //     }
        // }, 200);
    }

    $('.quickview-mobile-carousel').find('.carousel-inner:has(.slick-track:not(.dragged))').on('afterChange', function (e, slick, currentSlide) {
        var isFirst = currentSlide === 0;
        var isLast = currentSlide === slick.slideCount - 1;
        $selector.find('.slick-track').toggleClass('slick-track--dragged', !isFirst);
        $selector.find('.slick-track').toggleClass('slick-track--last', isLast && slick.slideCount > 1);
    });
}

/**
 * Selects a div to start the spinner based on the window width
 */
function startSpinner() {
    var selector = '.modal-content-wrapper';
    var $quickModal = $('.quick-modal.show');
    $quickModal.find('.modal-close-container').removeClass('show');
    $quickModal.find(selector).spinner().start();
}

/**
 * Does not apply display: none until after 300 ms
 * @param {Object} e - The event to prevent
 */
function slideQuickviewOut(e) {
    if (e) {
        e.preventDefault();
    }
    var minicartShow = $('.minicart-flyout.show').length > 0 || $('.minicart .popover.show').length > 0;
    $(document).off('focusin.bs.modal');

    if (minicartShow) {
        $('.modal-close-container').addClass('d-none');
        var animateObject = {};
        var isMobile = $(window).width() <= 992;
        if (isMobile) {
            var minicartHeight = $('.minicart-flyout.show').outerHeight();
            var minicartTop = $(window).outerHeight() - minicartHeight - 12;
            animateObject.height = `${minicartHeight}px`;
            animateObject.top = `${minicartTop}px`;
        } else {
            animateObject.width = `${$('.cart-sheet').outerWidth()}px`;
            animateObject.right = 0;
        }
        if ($('.veil').length) $.spinner().stop();
        startSpinner();
        $('.veil').addClass('fade-out');
        $('.veil .underlay').animate({
            opacity: 1
        }, 500, function () {
            setTimeout(function () {
                if (isMobile) {
                    $('#quickViewModal.quick-modal .default-quick-view-dialog').addClass('sync-minicart');
                } else {
                    $('.veil').animate(animateObject, 500);
                    $('.quick-modal .modal-float').addClass('d-none');
                }
            }, 150); // Delay to allow fade-out transition
        });
    } else {
        $('.quick-modal, .modal-close-container').removeClass('show');
    }

    var timeout = $('.veil').length > 0 ? 1300 : 300;

    setTimeout(function () {
        $('.quick-modal').modal('hide');
        $('#quickViewModal.quick-modal .default-quick-view-dialog').removeClass('sync-minicart');
        $('body').toggleClass('hide-zendesk', minicartShow); // Keeps zendesk hidden beneath item added to bag sheet
    }, timeout);
}

function setUpModalElement(id) {
    var $modal = $('#' + id);
    if ($modal.find('.color-attribute .selected').length) {
        var attributeParentContainer = $modal.find('.color-attribute .selected').parent().parent().prevAll('span:first').length ? $modal.find('.color-attribute .selected').parent().parent() : $modal.find('.color-attribute .selected').parent().parent().parent();
        attributeParentContainer.prevAll('span:first')
            .find('.selected-attr')
            .html($modal.find('.color-attribute .selected').data('attr-title').toUpperCase())
            .removeClass('d-none');
        if (attributeParentContainer.prevAll('span:first').length === 0) {
            $modal.find('.color-attribute .selected').closest('.product-attribute')
            .find('.selected-attr')
            .html($modal.find('.color-attribute .selected').data('attr-title').toUpperCase())
            .removeClass('d-none');
        }
        var $colorButton = $modal.find('.color-attribute.selected');
        var $newTextDiv = attributeParentContainer.prevAll('span:first')
            .find('.new-color-text');
        base.methods.toggleNewColorText($colorButton, $newTextDiv);

        var $finalSaleDiv = attributeParentContainer.prevAll('span:first')
            .find('.final-sale-text');
        base.methods.toggleFinalSaleText($colorButton, $finalSaleDiv);
    }
    scrollMore.update($modal);
    $('body').trigger('quickview:change');
}

function handleError(data) {
    slideQuickviewOut();
    if ($('.quick-view-messages').length === 0) {
        $('body').append('<div class="quick-view-messages"></div>');
    }
    var errorMessage = data.errorMessage || data.responseJSON ? `Invalid style: ${data.responseJSON.queryString.split('pid=')[1].split('&')[0]}` : null;
    if (errorMessage) {
        var errorHtml = `<div class="alert alert-danger quick-view-alert text-center
            fade show" role="alert">${errorMessage} </div>`;
        $('.quick-view-messages').append(errorHtml).css('top', `${$('header').outerHeight()}px`);
        setTimeout(function () {
            $('.quick-view-alert').remove();
        }, 3000);
    }
    $.spinner().stop();
}

function onAllImagesLoaded(element, callback) {
    let images = element.querySelectorAll('img');
    let imagesToLoad = images.length;
    let imagesLoaded = 0;

    if (imagesToLoad === 0) {
        callback(); // No images, trigger immediately
        return;
    }

    function imageLoaded() {
        imagesLoaded++;
        if (imagesLoaded === imagesToLoad) {
            callback();
        }
    }

    images.forEach(img => {
        if (img.complete) {
        // If the image is already loaded (e.g., from cache),
        // call imageLoaded() immediately.
            imageLoaded();
        } else {
            img.addEventListener('load', imageLoaded);
            img.addEventListener('error', imageLoaded); // Consider error case
        }
    });
}

function handleAllImagesLoaded() {
    $('#quickViewModal, #editProductModal').find('.modal-float').removeClass('d-none');
    $('#quickViewModal, #editProductModal').each(function () {
        // Re-measured on every size change, not once (see quickViewScrollMore)
        scrollMore.watch($(this));
    });
    $.spinner().stop();
}

function showReviews() {
    var $quickviewRatings = $('.quickview-ratings');
    var bvScout = $quickviewRatings.data('bv-scout');

    if (bvScout) {
        var scoutScript = '<script async type="text/javascript" src="' + bvScout + '"></script>';
        $('#quickViewModal .modal-body').eq(0).append(scoutScript);

        window.bvCallback = function (BV) {
            if (typeof BV !== 'undefined') {
                if (typeof BV.reviews !== 'undefined') {
                    BV.reviews.on('show', function () {
                        // This line assumes SFRA collapsible panels and is called when clicking on the review summary
                        $('.row.reviews:not(.active)').toggleClass('active');
                    });
                }
                if (typeof BV.questions !== 'undefined') {
                    BV.questions.on('show', function () {
                        // This line assumes SFRA collapsible panels and is called when clicking on the Q&A summary
                        $('.row.questions:not(.active)').toggleClass('active');
                    });
                }
            }
        };
    }

    var getBVDataCounter = 0;

    var getBVData = setInterval(function () {
        getBVDataCounter++;
        const numReviews = parseInt($quickviewRatings.find('.bv_numReviews_text').eq(0).text().replace(/[()]/g, ''), 10);

        if (numReviews === 0) {
            $quickviewRatings.addClass('d-none');
            $quickviewRatings.find('.bv_ratings_summary').remove();
            $quickviewRatings.find('.bv_war_button').text('Write the First Review');
            $quickviewRatings.find('.custom-bv-show').addClass('d-block');
            getBVDataCounter = 0;
            clearInterval(getBVData);
        } else if (numReviews > 0) {
            $quickviewRatings.find('.bv_war_button').attr('style', 'display: none !important');
            $quickviewRatings.find('.custom-bv-show').addClass('d-block');
            getBVDataCounter = 0;
            clearInterval(getBVData);
        }

        if (getBVDataCounter === 20) {
            getBVDataCounter = 0;
            clearInterval(getBVData);
        }
    }, 1500);
}

function ensureCarouselStatus($modal) {
    const modalId = $modal.attr('id') || 'modal';
    const statusId = `${modalId}-carouselStatus`;

    if ($modal.closest('.carouselStatus').length === 0) {
        const $status = $('<span>', {
            id: statusId,
            class: 'sr-only carouselStatus',
            'aria-live': 'polite'
        });
        $modal.find('.modal-float').prepend($status);
    }
}

function ensureVideoControlsAccessible($item) {
    const btn = $item.find('.vjs-big-play-button')[0];
    if (!btn) return;

    btn.removeAttribute('aria-hidden');
    if (btn.tabIndex < 0) btn.tabIndex = -1;

    if (!btn.getAttribute('aria-label')) {
        btn.setAttribute('aria-label', 'Play product video');
    }
    const status = $item.closest('.modal').find('.carouselStatus').attr('id');
    btn.setAttribute('aria-describedby', status);
}

function moveFocus(index, $items, $wrapper) {
    $items.each(function (i, el) {
        const $item = $(el);
        const isActive = i === index;
        const isVideo = $item.find('video').length > 0 || $item.find('.vjs-big-play-button').length > 0;

        $item.toggleClass('active', isActive)
         .toggleClass('hide', !isActive)
         .attr('aria-selected', isActive ? 'true' : 'false')
         .attr('aria-checked', isActive ? 'true' : 'false');

        if (isVideo) ensureVideoControlsAccessible($item);
        if (isActive) {
            $wrapper.attr('aria-activedescendant', $item.attr('id'));
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });

            // const img = $item.find('img')[0];
            // const label = img.getAttribute('aria-label') || img.alt || '';
            const pos = $item.attr('aria-posinset') || (i + 1);
            const size = $item.attr('aria-setsize') || $items.length;
            const $status = $wrapper.closest('.modal').find('.carouselStatus');
            const baseText = isVideo ? `Video ${pos} of ${size}.` : `Image ${pos} of ${size}.`;
            const hint = isVideo ? 'Press Enter to play.' : '';
            const newText = `${baseText} ${hint}`.trim();

            if ($status.text().trim() === '') {
                setTimeout(() => {
                    $status.text(newText);
                }, 700);
            } else {
                $status.text(newText);
            }
        }
    });
}

/**
 * Initializes keyboard navigation (ArrowUp/ArrowDown) for the image carousel inside a modal.
 *
 * This function sets up ARIA-compliant keyboard interaction by allowing users to
 * navigate between `.carousel-item` elements using the keyboard. It also manages
 * `aria-selected` and `aria-activedescendant` attributes for accessibility.
 *
 * Notes:
 * - Attaches event listeners with namespace `.carousel-nav` to prevent duplication.
 * - Automatically removes any previous listeners to avoid memory leaks.
 * - Scrolls the active item into center view for better visibility.
 *
 * @param {jQuery} $modal - The jQuery-wrapped modal element containing the carousel.
 */
function initQuickviewCarouselKeyboardNav($modal) {
    const $wrapper = $modal.find('.modal-float .carousel-inner');
    if (!$wrapper.length) return;
    ensureCarouselStatus($modal);

    $wrapper.attr({ tabindex: '0', role: 'group', 'aria-label': 'Product images' });
    $wrapper.find('.vjs-big-play-button').attr('tabindex', '-1');

    const $items = $wrapper.find('.carousel-item');
    const total = $items.length;

    $items.each(function (_, el) {
        $(el).attr({
            role: 'option'
        });
    });

    let currentIndex = Math.max(0, $items.index($items.filter('.active').first()));

    const onKey = (e) => {
        const $from = $(e.target).closest('.carousel-item');
        if ($from.length) {
            const idx = $items.index($from);
            if (idx !== -1) currentIndex = idx;
            $wrapper.focus();
        }

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            if (currentIndex < total - 1) {
                currentIndex++;
                moveFocus(currentIndex, $items, $wrapper);
            }
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            if (currentIndex > 0) {
                currentIndex--;
                moveFocus(currentIndex, $items, $wrapper);
            }
        } else if (e.key === 'Home') {
            e.preventDefault(); currentIndex = 0; moveFocus(currentIndex, $items, $wrapper);
        } else if (e.key === 'End') {
            e.preventDefault(); currentIndex = total - 1; moveFocus(currentIndex, $items, $wrapper);
        } else if (e.key === 'Enter' || e.key === ' ') {
            const $activeItem = $items.eq(currentIndex);
            const $playBtn = $activeItem.find('.vjs-big-play-button');
            const $pauseBtn = $activeItem.find('.pdp-video-pause-button');
            const isPaused = $activeItem.find('.vjs-paused');
            if (isPaused.length && $playBtn.length) {
                e.preventDefault();
                $playBtn.trigger('click');
            } else if ($pauseBtn.length) {
                e.preventDefault();
                $pauseBtn.trigger('click');
            }
        }
    };

    $wrapper.off('keydown.kv focusin.kv')
        .on('keydown.kv', onKey)
        .on(
            'focusin.kv',
            '.carousel-item:not(.pdp-video), .carousel-item:not(.pdp-video) img',
            () => $wrapper.focus()
        );
    moveFocus(currentIndex, $items, $wrapper);
    $wrapper.focus();
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 * @param {string} id - ID of the modal to target
 * @param {Object} options - Additional options (e.g., qsTriggerSource)
 */
function fillModalElement(selectedValueUrl, id, options) {
    var $modal = $('#' + id);
    $modal.find('.modal-content').spinner().start();
    var url = selectedValueUrl;
    if (url.indexOf('quickview=true') === -1) {
        url += (url.indexOf('?') !== -1 ? '&' : '?') + 'quickview=true';
    }
    $('body').toggleClass('hide-zendesk', true);
    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            if (data.error) {
                handleError(data);
            } else {
                var parsedHtml = parseHtml(data.renderedTemplate);

                // Send qsOpened event when HTML successfully loaded
                if (options && options.qsTriggerSource) {
                    var qsOriginUrl = window.location.href;
                    var eventData = {
                        event: 'qsOpened',
                        qsOriginUrl: qsOriginUrl,
                        qsSheetType: 'singleProduct',
                        qsTriggerSource: options.qsTriggerSource || 'recommender'
                    };

                    window.dataLayer.push(eventData);
                }

                // var $close = $modal.find('.modal-header.quickview-header .close').clone();
                // .modal-float is reused between openings: drop the previous product's "scrolled" state / position
                $modal.find('.modal-float').html(parsedHtml.float).addClass('d-none')
                    .removeClass('scrolled')
                    .scrollTop(0);
                $modal.find('.modal-header.quickview-header').empty().html(parsedHtml.header);
                $modal.find('.modal-body.quickview-body').empty().html(parsedHtml.body);
                $modal.find('.modal-footer.quickview-footer').html(parsedHtml.footer);

                if ($modal.find('.modal-float').length > 0) {
                    onAllImagesLoaded($modal.find('.modal-float').get(0), handleAllImagesLoaded);
                }

                $modal.find('.size-chart').attr('href', data.productUrl);
                $modal.find('.modal-header.quickview-header .close .sr-only').text(data.closeButtonText);
                $modal.find('.enter-message').text(data.enterDialogMessage);
                setUpModalElement(id);
                $modal.find('.modal-close-container').addClass('show');
                $modal.modal('show');
                floatingLabel.loadFloatingLabel();
                base.loadZoom();
                showReviews();

                $('#sizeChartModalQuickview, #sizeChartModalQuickviewMobile').on('show.bs.modal', function () {
                    $('.quickview-size-chart-modal-backdrop').remove();
                    $('.quick-modal.show .modal-content.quickview-content').append('<div class="quickview-size-chart-modal-backdrop"></div>');
                });

                $('#sizeChartModalQuickview, #sizeChartModalQuickviewMobile').on('hide.bs.modal', function () {
                    $('.quickview-size-chart-modal-backdrop').remove();
                });
                if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
                    $modal.find('.color-attribute.swatch-attribute').addClass('safari-mac');
                }

                if ($modal.find('.product-detail.egiftcard').length) {
                    eGiftCard.updateAddToCartButton($modal.find('.product-detail.egiftcard'));
                }

                if ($modal.find('.date-group').length > 0) {
                    eGiftCard.initDeliveryDatePicker($('#editProductModal'));

                    var selector = null;
                    if ($('#editProductModal').find('#giftMessage').length > 0) {
                        selector = '#editProductModal #giftMessage';
                    } else if ($('#editProductModal').find('#quickview-giftMessage').length > 0) {
                        selector = '#editProductModal #quickview-giftMessage';
                    }

                    if (selector) {
                        giftMessage.updateCounter(selector);
                    }
                }
                loadPDPVideos();
                initQuickviewCarouselKeyboardNav($modal);
            }
        },
        error: function (data) {
            handleError(data);
        },
        complete: function () {
            if ($('.veil').length > 0 && !$modal.find('.modal-float').length) {
                $.spinner().stop();
            }
        }
    });
}

/**
 * Generates an accessible modal window and injects it into the DOM.
 * @param {string} id - Modal ID
 * @param {string} arialabel - Accessible label for the modal (e.g. "Quick Shop for Nike Air Max")
 */
function getModalHtmlElement(id, arialabel) {
    $('#' + id).remove();
    const ariaLabelAttr = arialabel && arialabel !== 'undefined' ? ` aria-label="${arialabel}"` : '';
    const htmlString = `<!-- Modal -->
        <div class="modal quick-modal" id="${id}" tabindex="-1" aria-hidden="true" data-backdrop="static">
            <span class="enter-message sr-only" ></span>
            <div class="modal-dialog quick-view-dialog default-quick-view-dialog"
                role="dialog"
                aria-modal="true"
                ${ariaLabelAttr}
                tabindex="-1"
            >`
            + '<!-- Modal content-->'
                + '<div class="modal-content-wrapper">'
                    + '<div class="modal-float"></div>'
                    + '<div class="modal-content quickview-content">'
                        + '<div class="modal-close-container">'
                            + '<div class="draggable-handle d-block d-md-none mx-auto"></div>'
                            + '<button type="button" class="close modal-close" aria-label="Close Quick Shop">'
                                + '<span class="sr-only"> </span>'
                            + '</button>'
                        + '</div>'
                        + '<div class="modal-header quickview-header"></div>'
                        + '<div class="modal-body quickview-body"></div>'
                        + '<div class="modal-footer quickview-footer"></div>'
                    + '</div>'
                + '</div>'
            + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

function showQuickview(e, selectedValueUrl) {
    e.preventDefault();
    var arialabel = '';
    var qsTriggerSource = 'recommender'; // Default value

    if (e.currentTarget) {
        window.quickviewTriggerEl = e.currentTarget; // Save the focused element
        arialabel = $(e.currentTarget).data('modal-label') ||
                    $(e.currentTarget).find('[data-modal-label]').data('modal-label') || '';

        // Determine qsTriggerSource based on container
        var $element = $(e.currentTarget);
        if ($element.closest('.search-results').length > 0) {
            qsTriggerSource = 'plp_product_tile';
        } else if ($element.closest('.cart-sheet').length > 0) {
            qsTriggerSource = 'atc';
        }
    }
    $(e.target).trigger('quickview:show');
    getModalHtmlElement('quickViewModal', arialabel);
    fillModalElement(selectedValueUrl, 'quickViewModal', {
        qsTriggerSource: qsTriggerSource
    });
}

// CUSTOM
quickViewBase.showModals = function () {
    $(document).on('shown.bs.modal', '#quickViewModal', initMobileSlider);
    $(document).on('shown.bs.modal', '.modal.quick-modal', function () {
        $(this).removeAttr('aria-modal'); // ADA aria-modal used where it is not allowed
        $(this).find('.quantity-select option').each(function () {
            $(this).attr('aria-selected', $(this).is(':selected'));
        });
    });
};

quickViewBase.closeModals = function () {
    // Prevents overlap with size chart close button
    $(document).on('shown.bs.modal', '#sizeChartModalQuickview, #sizeChartModalQuickviewMobile', function () {
        $('.quick-modal .modal-close-container').removeClass('show');
        $(this).find('.modal-dialog').focus();
    });

    $(document).on('hidden.bs.modal', '#sizeChartModalQuickview, #sizeChartModalQuickviewMobile', function () {
        if (!$('.quick-modal').hasClass('show')) {
            return;
        }

        $('.quick-modal .modal-close-container').addClass('show');
        $('body').addClass('modal-open').css('padding-right', '15px');
    });

        // Slides quickview sheet out, unless click is from size chart
    $(document).on('click keydown', '.quick-modal .close', function (e) {
        if (!(e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter'))) {
            return;
        }

        e.preventDefault();

        if ($(this).closest('.size-chart-modal').length > 0) {
            $(this).closest('.size-chart-modal').modal('hide');
        } else if ($('#quickViewModal.show').is(':visible') || $('#editProductModal.show').is(':visible')) {
            slideQuickviewOut(e);
        }
    });


    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
            if ($('.quick-modal.show').length && !$('#sizeChartModalQuickview, #sizeChartModalQuickviewMobile').is(':visible')) {
                if ($('.flatpickr-calendar.open').length) {
                    return;
                }
                e.preventDefault();
                e.stopPropagation();
                slideQuickviewOut(e);
            }
        }
    }, true);

    $(document).on('click', '.quick-modal', function (e) {
        if ($(e.target).hasClass('modal') && !$(e.target).hasClass('size-chart-modal')) {
            slideQuickviewOut(e);
        }
    });

    // Restores focus to the tile we just clicked on
    $(document).on('hidden.bs.modal', '.quick-modal', function (e) {
        var $modal = $(e.target);
        if ($modal.is('#quickViewModal')) {
            e.stopImmediatePropagation();
            e.preventDefault();
            var $trigger = $(window.quickviewTriggerEl);
            var productTile;
            var quickViewBtn = $('.shop-the-look .product-tile.is-focused .image-container button.quickview.shop-the-look__quickview:not(.slick-arrow)');

            if ($('.minicart-flyout.show').is(':visible')) {
                var $dialog = $('.minicart-flyout.show');
                var headerText = $.trim($dialog.find('#cart-header-title').text());
                if (headerText) {
                    $dialog.attr('aria-label', headerText + ' modal');
                }
                window.quickviewTriggerEl = null;
                $dialog.focus();
            } else if ($trigger.hasClass('quickview--default')) {
                productTile = $trigger.closest('.product-tile');
                if (productTile.length) {
                    productTile.focus();
                    productTile.addClass('is-focused');

                    quickViewBtn
                        .one('blur', function () {
                            $(this).closest('.is-focused').removeClass('is-focused');
                        });
                }
                $trigger.addClass('d-flex').focus();
                setTimeout(function () {
                    $trigger.removeClass('d-flex');
                }, 0);
            } else if ($trigger.hasClass('product-tile') && $trigger.data('target') === '#quickViewModal') {
                var btn = $trigger.find('button.quickview:visible').first();
                productTile = btn.closest('.product-tile');
                if (btn.length && focusHelper.isFocusable(btn)) {
                    var qvBtn = btn.closest('.product-tile');
                    if (qvBtn.length) {
                        qvBtn.addClass('is-focused');

                        quickViewBtn
                            .one('blur', function () {
                                $(this).closest('.is-focused').removeClass('is-focused');
                            });
                    }
                    var ua = navigator.userAgent || '';
                    var isWindows = /Windows/i.test(ua);// Detect Windows (NVDA/JAWS environment)
                    var prevTitle = btn.attr('aria-label');
                    if (isWindows && prevTitle) {
                        btn.attr('aria-label', ' ');
                    }
                    if (productTile.length) {
                        productTile.focus();
                    }

                    btn.focus();
                    if (isWindows) {
                        // Trigger an accessible announcement via aria-live ONLY on Windows
                        var live = document.getElementById('A11yAnswer');
                        if (!live) {
                            live = document.createElement('div');
                            live.id = 'A11yAnswer';
                            live.setAttribute('role', 'status');
                            live.setAttribute('aria-live', 'polite');
                            live.setAttribute('aria-atomic', 'true');
                            live.className = 'sr-only';
                            document.body.appendChild(live);
                        }
                        var label = (prevTitle || '').trim();
                        live.textContent = label;
                        // Restore the title after a short delay to avoid a duplicate announcement
                        if (prevTitle) {
                            setTimeout(function () {
                                btn.attr('aria-label', prevTitle);
                            }, 500);
                        }
                    }
                }
            } else if (focusHelper.isFocusable($trigger) && document.activeElement !== $trigger[0]) {
                $trigger.focus();
            }
            return;
        }
    });
};

quickViewBase.loadButtons = function () {
    $('body').on('quickview:loadButtons', function () {
        $('.quickview').removeClass('d-none');
    });

    $(document).ready(function () {
        $('body').trigger('quickview:loadButtons');

        $('body').on('click', '.quickview--default', function (e) {
            $(this).addClass('selected-quickview');
            var selectedValueUrl = $(this).closest('button.quickview').length === 1 ? $(this).closest('button.quickview').attr('href') : $(this).closest('span.quickview').attr('href');
            showQuickview(e, selectedValueUrl);
        });

        $('body').on('click', '.product-tile--quick-rec', function (e) {
            if ($(e.target).closest('.quickview--default').length) {
                return;
            }
            var selectedValueUrl = $(this).attr('href');
            showQuickview(e, selectedValueUrl);
        });

        // Send FullPdpOpened event when clicking "View Full PDP" link
        $('body').on('click', '.pdp-link', function () {
            let event = {
                event: 'FullPdpOpened',
                qsOriginUrl: window.location.href,
                qsSheetType: 'singleProduct'
            };

            window.dataLayer.push(event);
        });
    });
};

// Send quickShopAddToBag event once the backend confirms the item was added to cart
quickViewBase.trackAddToCart = function () {
    $('body').on('product:afterAddToCartGtm', function (e, data) {
        if ($('.quick-modal.show').length === 0) {
            return;
        }

        var gtmProductDetails = data.gtmProductDetails;
        var atcData = {
            color: gtmProductDetails.color || '',
            color_value: gtmProductDetails.color_value || '',
            contentsquare_color_value: gtmProductDetails.contentsquare_color_value,
            quantity: data.quantity,
            size: gtmProductDetails.size || '',
            collegiate: gtmProductDetails.isEmbroidered,
            dmpk: gtmProductDetails.length || gtmProductDetails.inseam || gtmProductDetails.hand || gtmProductDetails.width || '',
            style_number: gtmProductDetails.manufacturerSKU,
            master_upc: gtmProductDetails.masterProductId,
            upc: gtmProductDetails.variantID || ''
        };

        var qsContext = {
            qsOriginUrl: window.location.href,
            qsSheetType: 'singleProduct'
        };

        var stlContext = quickShopDataLayer.getShopTheLookContext();

        quickShopDataLayer.pushQuickShopAddToBagEvent(qsContext, stlContext, atcData);
    });
};

quickViewBase.dragModal = function () {
    function closeQuickView() {
        if ($('.quick-modal').hasClass('show')) {
            slideQuickviewOut();
        }
    }

    var touchStartY = 0;

    function toggleFlyout(e) {
        // Does not toggle flyout if using desktop view
        if (!$('.quickview-desktop-carousel').is(':visible')) {
            var touchEndY = e.originalEvent.touches[0].clientY;
            var $target = $(e.target);
            var $scrollable = $target.closest('.modal-body.quickview-body, .modal-header.quickview-header');
            if ($scrollable.length) {
                return;
            }

            if (touchEndY - touchStartY > 20 && $(e.target).closest('#sizeChartModalQuickview, #sizeChartModalQuickviewMobile').length === 0) {
                closeQuickView();
            }
        }
    }

    var debounceFlyout = debounce(toggleFlyout, 50);

    $('body').on('touchstart', '.default-quick-view-dialog', function (e) {
        touchStartY = e.originalEvent.touches[0].clientY;
    });

    $('body').on('touchmove', '.default-quick-view-dialog', function (e) {
        debounceFlyout(e);
    });
};

quickViewBase.updateView = function () {
    var debounceResize = debounce(function () {
        if ($('.quick-modal').is(':visible')) {
            $('body').trigger('quickview:change');
        }
    }, 50);

    $(window).on('resize', function () {
        debounceResize();
    });

    $('body').on('quickview:change', function () {
        $('.quick-modal .modal-float:not(.scrolled)').on('scroll', function () {
            $(this).addClass('scrolled');
        });
        initMobileSlider();
    });
};

quickViewBase.errorHandling = function () {
    $(document).on('afterCollapseHeader', function () {
        $('.quick-view-messages').css('top', `${$('header').outerHeight()}px`);
    });
};

quickViewBase.customTrigger = function () {
    $(document).on('click', 'button[data-quick-shop-pid][data-quick-shop-color]', function () {
        var quickTriggerUrl = $('[data-quick-trigger-url]').data('quickTriggerUrl');
        if (quickTriggerUrl) {
            getModalHtmlElement('quickViewModal');
            quickTriggerUrl += `?pid=${$(this).data('quickShopPid')}_${$(this).data('quickShopColor')}`;
            fillModalElement(quickTriggerUrl, 'quickViewModal', {
                qsTriggerSource: 'recommender'
            });
        }
    });
};

// UPDATED BASE
quickViewBase.beforeUpdateAttribute = function () {
    $('body').on('product:beforeAttributeSelect', function () {
        startSpinner();
    });
};

quickViewBase.updateAttribute = function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview>.bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container)
                .find('.product-id').text(response.data.product.id);
        } else if ($('.set-items').length) {
            response.container.find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
            $('.modal.show .full-pdp-link')
                .attr('href', response.data.product.selectedProductUrl);
        }

        $('.quick-modal .modal-close-container').addClass('show');
    });
};

quickViewBase.showSpinner = function () {
    $('body').on('product:beforeAddToCart', function () {
        if ($('.quick-modal.show').length > 0) {
            startSpinner();
        }
    });
};

quickViewBase.hideDialog = function () {
    // Override post-ATC behavior
    $('body').on('product:afterAddToCart', function () {
        // $('#quickViewModal').modal('hide');
    });
};

quickViewBase.showQuickview = function () {
    // Override click behavior (handled in loadButtons)
    $('body').on('click', '.quickview', function () {
        // e.preventDefault();
        // var selectedValueUrl = $(this).closest('a.quickview').attr('href');
        // $(e.target).trigger('quickview:show');
        // getModalHtmlElement();
        // fillModalElement(selectedValueUrl);
    });
};

quickViewBase.updateAvailability = function () {
    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products + leave empty li for styling purposes if blank
        var newMessage = response.message && response.message !== '' ? response.message : '';

        var $availabilityMsg = $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg');

        // Hide content visually (preserving space) to avoid layout shift,
        // then update after a brief delay to allow attribute selection to be announced first
        $availabilityMsg.css('visibility', 'hidden');

        setTimeout(function () {
            $availabilityMsg.html(newMessage);
            $availabilityMsg.css('visibility', '');
        }, 100);

        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });
};

quickViewBase.focusQuickview = function () {
    $('body').on('shown.bs.modal', '#quickViewModal', function (e) {
        var $modal = $(e.target);
        if ($modal.is('#quickViewModal')) {
            // $modal.siblings().attr('aria-hidden', 'true');
            $modal.find('.modal-dialog').focus();
        }
    });
    $('body').on('hidden.bs.modal', '#quickViewModal', function (e) {
        var $modal = $(e.target);
        if ($modal.is('#quickViewModal')) {
            // $modal.siblings().attr('aria-hidden', 'false');
        }
    });
};

quickViewBase.availability = base.availability;

quickViewBase.addToCart = function () {
    // Only add ATC listener if PDP hasn't added it already
    if ($('.container.product-detail').length === 0 && $('.embroidery-landing-container').length === 0) {
        base.addToCart();
    }
};

quickViewBase.trapQuickviewFocus = function () {
    $('body').on('keydown', '#quickViewModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#quickViewModal'
        };
        focusHelper.setTabNextFocus(focusParams);
    });
};

quickViewBase.bindSwatchArrowFocusIncludeAll = function (containerSelector) {
    $(document).on('keydown', containerSelector + ' .swatch-attribute', function (e) {
        var code = e.which || e.keyCode;
        if (code !== 37 && code !== 38 && code !== 39 && code !== 40) return; // only arrows

        var $container = $(this).closest(containerSelector);
        var $btns = $container.find('.swatch-attribute');

        if (!$btns.length) return;

        var idx = $btns.index(this);
        var dir = (code === 39 || code === 40) ? 1 : -1; // Right/Down -> next, Left/Up -> back
        var next = (idx + dir + $btns.length) % $btns.length;
        e.preventDefault();
        var el = $btns.get(next);

        if (el && typeof el.focus === 'function' && el !== document.activeElement) {
            el.focus();
        }
    });
};

quickViewBase.bindSwatchArrowFocusIncludeAll('.swatch-attribute-list');
quickViewBase.updateAddToCart = function () {
    $('body').on('product:updateAddToCart', function (e, response) {
        // update local add to cart (for sets)
        var addToCart = $('button.add-to-cart', response.$productContainer);
        addToCart.attr('disabled', (!response.product.available));
        // Check if this is an eGift card product - if so, let eGiftCard.js handle it
        var isEGiftCard = response.product && response.product.isEGiftCard;
        if (isEGiftCard && response.product && response.product.available) {
            $('body').trigger('egiftcard:updateButton');
            return;
        }
        if (response.product.available) {
            addToCart.text(addToCart.data('available-msg'));
        } else {
            addToCart.text(addToCart.data('unavailable-msg'));
        }
        if (response.product.readyToOrder) {
            $('button.add-to-cart').closest('.cart-and-ipay').find('.invalidAttr').addClass('d-none');
            $('.invalid-attributes-msg').find('.invalidAttr').addClass('d-none');
            addToCart.removeClass('disabled');
        } else {
            addToCart.text(addToCart.data('selectsize-msg'));
        }
        var enable = $('.product-availability').toArray().every(function (item) {
            return $(item).data('available') && $(item).data('ready-to-order');
        });
        $('button.add-to-cart-global').attr('disabled', !enable);
    });
};
quickViewBase.setColorAttribute = base.setColorAttribute;
quickViewBase.methods = {
    getModalHtmlElement: getModalHtmlElement,
    fillModalElement: fillModalElement,
    slideQuickviewOut: slideQuickviewOut,
    initQuickviewCarouselKeyboardNav: initQuickviewCarouselKeyboardNav
};

module.exports = quickViewBase;
